<template>

  <div v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-container>
      <el-header>
        <head_page :head_page_type=false ref="head_page"></head_page>
      </el-header>
      <el-main>
        <div id='choose_city'>
          <head_menu :is-home-page=true :has-back=true @go-back-click="backToLogin" >
           <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:5px;font-size: 20px;">
                {{chosen_city=='first'?'Global':chosen_city}}
              </div>
            </template>
            <template #button-group-right>

            
                <el-button style = "margin-right:10px"  v-if="is_external_user" @click = "goChangePwd">{{ $t('message.change_password') }}
                </el-button>
              <el-badge v-if="view_nanjing || view_wuhan || view_shenzhen|| view_chongqing || view_chengdu|| view_shanghai" :value="dataValueBadge" class="item">

                <el-dropdown><el-button  v-if="is_admin">{{ $t('message.UserMangement') }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item  @click.native="goInternalUserMangement">内部用户管理</el-dropdown-item>
                  <el-dropdown-item @click.native="goExternalUserMangement">外部用户管理</el-dropdown-item>
   </el-dropdown-menu>
</el-dropdown>
                <el-button style="margin-left:0px!important" v-if="view_package_list && !is_external_user" @click="goPackage">
                   {{ $t('message.Package_History') }}
                </el-button>
                <el-dropdown><el-button v-if="view_statistics && !is_external_user">{{ $t('message.Statistics') }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item  @click.native="goBussinessStatistics">{{$t('message.Bussiness_Statistic')}}</el-dropdown-item>
                  <el-dropdown-item @click.native="goStatistics">{{$t('message.Activities_Statistic')}}</el-dropdown-item>
   
  </el-dropdown-menu>
</el-dropdown>
                <el-button @click="goHistory">{{ $t('message.History') }}
                </el-button>
              </el-badge>
            </template>
            <template #button-group-right-toggle>
              <toggle_menu>
                <template #toggle-content>
                  <!--
                  <el-menu-item index="/package_history" :route="{ name: 'package_history' }">
                    {{ $t('message.Package_History') }}
                  </el-menu-item>
                  -->
                  <el-menu-item index="/statistics" :route="{ name: 'statistics' }">
                    {{ $t('message.Statistics') }}
                  </el-menu-item>
                  <el-menu-item index="/history" :route="{ name: 'history' }">
                    {{ $t('message.History') }}
                  </el-menu-item>
                </template>
              </toggle_menu>
            </template>
          </head_menu>
          <div style="background-color: #f8f8f9;" id="choose_city_content">
            <br />
            <el-tabs id="choose_city_tab" v-model="activeName" type="card" @tab-click="handleClick" :stretch="pageWidth < 768"> 
              <el-tab-pane :label="$t('message.Global')" name="first">
                <div class="level2_div">
                  <p class="p_city_title_global" >
                    <el-select  v-if="create_crosscity && !is_external_user" v-model="selected_cities" multiple collapse-tags :placeholder="$t('message.Please_Select')"
                      style="margin-right: 15px; width:180px; vertical-align: bottom;">
                      <el-option
                        v-for="item in city_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-button
                      v-if="create_crosscity && !is_external_user"
                      id="select_cities_button"
                      @click="doCrossCity">
                      {{ $t('message.Select_cities') }}
                    </el-button>
                    <br />
                    <br/>
                    <strong>{{day}}, </strong>{{date}}
                  </p>
                  <p class="p_city_content_global">
                    {{ $t('message.Hello') }}, {{user}}
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="view_nanjing" :label="$t('message.Nanjing')" name="Nanjing">
                <div class="level2_div level2_div_nj">
                  <el-row>
                    <el-col :sm="24" :md="12">
                      <p class="p_city_title">
                        <el-button v-if="view_nanjing"
                          style="text-align: center; margin-right: 20px;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white"
                          @click="doSubmit">
                          {{ $t('message.Select_this_city') }}
                        </el-button>
                        
                        <el-button v-if="inventory_nanjing && !is_external_user" @click="goInventoryList"
                                  style="text-align: center;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white">
                                  {{$t('message.Inventory_list')}}
                        </el-button>

                        <!--
                        <el-upload style="display: inline" v-if="inventory_nanjing" action='localhost:8080/posts/' accept=".xlsx">
                          <el-button style="text-align: center;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white">
                                  {{$t('message.Upload_inventory')}}
                          </el-button>
                        </el-upload>
                        -->

                        <br/>
                        <br/>
                        <strong>{{day}}, </strong>{{date}}
                      </p>
                      <p class="p_city_content">
                        {{ $t('message.Hello') }}, {{user}}
                      </p>
                    </el-col>
                    <el-col class="hidden-sm-and-down" :span="4" :offset="8">
                      <div style="text-align: right; color:white;font-size:50px">
                        <br/>
                        <p style="margin-right: 1em">{{ $t('message.Nanjing') }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="view_nanjing" class="hidden-sm-and-down">
                    <el-col  :offset="13" :span="4" >
                      <el-select  v-model="selected_package_package_id" :placeholder="$t('message.Please_Select')" >
                        <el-option
                          v-for="item in published_package_list"
                          :key="item.package_id"
                          :label="item.package_name"
                          :value="item.package_id"
                          >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="5">
                      <el-card shadow="always">
                        <div>
                        <h3>{{this.selected_package.package_name}}</h3>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="goPackageBoard" :disabled="notExistPackageId">{{ $t('message.Select') }}</el-button>
                        </div>
                          <div>{{ $t('message.Cost') }}: {{this.selected_package.package_price}}
                          </div>
                          <div>{{ $t('message.Buses_bodies') }}: {{this.selected_package.bus_body_qty}}
                          </div>
                          <div>{{ $t('message.Nbr_Of_Bus_Lines') }}: {{this.selected_package.bus_line_qty}}
                          </div>
                          <div>{{this.selected_package.description}}
                          </div>
                          <div>{{ $t('message.Package_Validity') }}: {{this.packageValidityPeriod}}
                          </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
                
              </el-tab-pane>
              
              <el-tab-pane v-if="view_wuhan || inventory_wuhan" :label="$t('message.Wuhan')" name="Wuhan">
                <div class="level2_div level2_div_wh">
                  <el-row>
                    <el-col :sm="24" :md="12">
                      <p class="p_city_title">
                        <el-button v-if="view_wuhan"
                          style="text-align: center; margin-right: 20px;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white"
                          @click="doSubmit">
                          {{ $t('message.Select_this_city') }}
                        </el-button>
                        
                        <el-button v-if="inventory_wuhan && !is_external_user" @click="goInventoryList"
                                  style="text-align: center;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white">
                                  {{$t('message.Inventory_list')}}
                        </el-button>


                        <br/>
                        <br/>
                        <strong>{{day}}, </strong>{{date}}
                      </p>
                      <p class="p_city_content">
                        {{ $t('message.Hello') }}, {{user}}
                      </p>
                    </el-col>

                    <el-col class="hidden-sm-and-down" :span="4" :offset="8">
                      <div style="text-align: right; color:white;font-size:50px">
                        <br>
                        <p style="margin-right: 1em">{{ $t('message.Wuhan') }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="view_wuhan" class="hidden-sm-and-down">
                    <el-col  :offset="13" :span="4" >
                      <el-select  v-model="selected_package_package_id" :placeholder="$t('message.Please_Select')" >
                        <el-option
                          v-for="item in published_package_list"
                          :key="item.package_id"
                          :label="item.package_name"
                          :value="item.package_id"
                          >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="5">
                      <el-card shadow="always">
                        <div>
                          <h3>{{this.selected_package.package_name}}</h3>
                          <el-button style="float: right; padding: 3px 0" type="text" @click="goPackageBoard" :disabled="notExistPackageId">{{ $t('message.Select') }}</el-button>
                        </div>
                        <div>{{ $t('message.Cost') }}: {{this.selected_package.package_price}}
                        </div>
                        <div>{{ $t('message.Buses_bodies') }}: {{this.selected_package.bus_body_qty}}
                        </div>
                        <div>{{ $t('message.Nbr_Of_Bus_Lines') }}: {{this.selected_package.bus_line_qty}}
                        </div>
                        <div>{{this.selected_package.description}}
                        </div>
                        <div>{{ $t('message.Package_Validity') }}: {{this.packageValidityPeriod}}
                        </div>
                      </el-card>
                    </el-col>
                    
                    </el-row>
                </div>
              </el-tab-pane>

              <el-tab-pane v-if="view_shenzhen || inventory_shenzhen" :label="$t('message.Shenzhen')" name="Shenzhen">
                <div class="level2_div level2_div_sz">
                  <el-row>
                    <el-col :sm="24" :md="12">
                      <p class="p_city_title">
                        <el-button v-if="view_shenzhen" style="text-align: center; margin-right: 20px;
                                            background-color: #254A6E; font-size:16px;border: #2C3E50;
                                            border-style: solid; margin-right: 20px;
                                            border-width:1px;color:white"
                           @click="doSubmit">
                          {{ $t('message.Select_this_city') }}
                        </el-button>
                        
                        <el-button v-if="inventory_shenzhen && !is_external_user" @click="goInventoryList"
                                  style="text-align: center;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white">
                                  {{$t('message.Inventory_list')}}
                        </el-button>
                        <br/>
                        <br/>
                        <strong>{{day}}, </strong>{{date}}
                      </p>
                      <p class="p_city_content">
                        {{ $t('message.Hello') }}, {{user}}
                      </p>
                    </el-col>

                    <el-col class="hidden-sm-and-down" :span="4" :offset="8">
                      <div style="text-align: right; color:white;font-size:50px">
                        <br>
                        <p style="margin-right: 1em">{{ $t('message.Shenzhen') }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="hidden-sm-and-down">
                    <el-col  :offset="13" :span="4" >
                      <el-select  v-model="selected_package_package_id" :placeholder="$t('message.Please_Select')" >
                        <el-option
                        v-for="item in published_package_list"
                        :key="item.package_id"
                        :label="item.package_name"
                        :value="item.package_id"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="5">
                      <el-card shadow="always">
                        <div>
                        <h3>{{this.selected_package.package_name}}</h3>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="goPackageBoard" :disabled="notExistPackageId">{{ $t('message.Select') }}</el-button>
                        </div>
                          <div>{{ $t('message.Cost') }}: {{this.selected_package.package_price}}
                          </div>
                          <div>{{ $t('message.Buses_bodies') }}: {{this.selected_package.bus_body_qty}}
                          </div>
                          <div>{{ $t('message.Nbr_Of_Bus_Lines') }}: {{this.selected_package.bus_line_qty}}
                          </div>
                          <div>{{this.selected_package.description}}
                          </div>
                          <div>{{ $t('message.Package_Validity') }}: {{this.packageValidityPeriod}}
                          </div>
                      </el-card>
                    </el-col>
                    </el-row>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="view_chongqing" :label="$t('message.Chongqing')" name="Chongqing">
                <div class="level2_div level2_div_cq">
                  <el-row>
                    <el-col :sm="24" :md="12">
                      <p class="p_city_title">
                        <el-button style="text-align: center; margin-right: 20px;
                                            background-color: #254A6E; font-size:16px;border: #2C3E50;
                                            border-style: solid;
                                            border-width:1px;color:white"
                          @click="doSubmit">
                          {{ $t('message.Select_this_city') }}
                        </el-button>
                        
                        <el-button v-if="inventory_chongqing && !is_external_user" @click="goInventoryList"
                                  style="text-align: center;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white">
                                  {{$t('message.Inventory_list')}}
                        </el-button>
                        <br/>
                        <br/>
                        <strong>{{day}}, </strong>{{date}}
                      </p>
                      <p class="p_city_content">
                        {{ $t('message.Hello') }}, {{user}}
                      </p>
                    </el-col>

                    <el-col class="hidden-sm-and-down" :span="4" :offset="8">
                      <div style="text-align: right; color:white;font-size:50px">
                        <br>
                        <p style="margin-right: 1em">{{ $t('message.Chongqing') }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="hidden-sm-and-down">
                    <el-col  :offset="13" :span="4" >
                      <el-select  v-model="selected_package_package_id" :placeholder="$t('message.Please_Select')" >
                        <el-option
                        v-for="item in published_package_list"
                        :key="item.package_id"
                        :label="item.package_name"
                        :value="item.package_id"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="5">
                      <el-card shadow="always">
                        <div>
                        <h3>{{this.selected_package.package_name}}</h3>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="goPackageBoard" :disabled="notExistPackageId">{{ $t('message.Select') }}</el-button>
                        </div>
                          <div>{{ $t('message.Cost') }}: {{this.selected_package.package_price}}
                          </div>
                          <div>{{ $t('message.Buses_bodies') }}: {{this.selected_package.bus_body_qty}}
                          </div>
                          <div>{{ $t('message.Nbr_Of_Bus_Lines') }}: {{this.selected_package.bus_line_qty}}
                          </div>
                          <div>{{this.selected_package.description}}
                          </div>
                          <div>{{ $t('message.Package_Validity') }}: {{this.packageValidityPeriod}}
                          </div>
                      </el-card>
                    </el-col>
                    </el-row>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="view_chengdu" :label="$t('message.Chengdu')" name="Chengdu">
                <div class="level2_div level2_div_cd">
                  <el-row>
                    <el-col :sm="24" :md="12">
                      <p class="p_city_title">
                        <el-button style="text-align: center; margin-right: 20px;
                                            background-color: #254A6E; font-size:16px;border: #2C3E50;
                                            border-style: solid;
                                            border-width:1px;color:white"
                          @click="doSubmit">
                          {{ $t('message.Select_this_city') }}
                        </el-button>
                        
                        <el-button v-if="inventory_chengdu && !is_external_user" @click="goInventoryList"
                                  style="text-align: center;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white">
                                  {{$t('message.Inventory_list')}}
                        </el-button>
                        <br/>
                        <br/>
                        <strong>{{day}}, </strong>{{date}}
                      </p>
                      <p class="p_city_content">
                        {{ $t('message.Hello') }}, {{user}}
                      </p>
                    </el-col>

                    <el-col class="hidden-sm-and-down" :span="4" :offset="8">
                      <div style="text-align: right; color:white;font-size:50px">
                        <br>
                        <p style="margin-right: 1em">{{ $t('message.Chengdu') }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="hidden-sm-and-down">
                    <el-col  :offset="13" :span="4" >
                      <el-select  v-model="selected_package_package_id" :placeholder="$t('message.Please_Select')" >
                        <el-option
                        v-for="item in published_package_list"
                        :key="item.package_id"
                        :label="item.package_name"
                        :value="item.package_id"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="5">
                      <el-card shadow="always">
                        <div>
                        <h3>{{this.selected_package.package_name}}</h3>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="goPackageBoard" :disabled="notExistPackageId">{{ $t('message.Select') }}</el-button>
                        </div>
                          <div>{{ $t('message.Cost') }}: {{this.selected_package.package_price}}
                          </div>
                          <div>{{ $t('message.Buses_bodies') }}: {{this.selected_package.bus_body_qty}}
                          </div>
                          <div>{{ $t('message.Nbr_Of_Bus_Lines') }}: {{this.selected_package.bus_line_qty}}
                          </div>
                          <div>{{this.selected_package.description}}
                          </div>
                          <div>{{ $t('message.Package_Validity') }}: {{this.packageValidityPeriod}}
                          </div>
                      </el-card>
                    </el-col>
                    </el-row>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="view_shanghai" :label="$t('message.Shanghai')" name="Shanghai">
                <div class="level2_div level2_div_sh">
                  <el-row>
                    <el-col :sm="24" :md="12">
                      <p class="p_city_title">
                        <el-button v-if="view_shanghai"
                          style="text-align: center; margin-right: 20px;
                                  background-color: #254A6E; font-size:16px;border: #2C3E50;
                                  border-style: solid;
                                  border-width:1px;color:white"
                          @click="doSubmit">
                          {{ $t('message.Select_this_city') }}
                        </el-button>

                        <br/>
                        <br/>
                        <strong>{{day}}, </strong>{{date}}
                      </p>
                      <p class="p_city_content">
                        {{ $t('message.Hello') }}, {{user}}
                      </p>
                    </el-col>
                    <el-col class="hidden-sm-and-down" :span="4" :offset="8">
                      <div style="text-align: right; color:white;font-size:50px">
                        <br/>
                        <p style="margin-right: 1em">{{ $t('message.Shanghai') }}</p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="!is_external_user" class="hidden-sm-and-down">
                    <el-col  :offset="13" :span="4" >
                      <el-select  v-model="selected_package_package_id" :placeholder="$t('message.Please_Select')" >
                        <el-option
                          v-for="item in published_package_list"
                          :key="item.package_id"
                          :label="item.package_name"
                          :value="item.package_id"
                          >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="5">
                      <el-card shadow="always">
                        <div>
                        <h3>{{this.selected_package.package_name}}</h3>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="goPackageBoard" :disabled="notExistPackageId">{{ $t('message.Select') }}</el-button>
                        </div>
                          <div>{{ $t('message.Cost') }}: {{this.selected_package.package_price}}
                          </div>
                          <div>{{ $t('message.Buses_bodies') }}: {{this.selected_package.bus_body_qty}}
                          </div>
                          <div>{{ $t('message.Nbr_Of_Bus_Lines') }}: {{this.selected_package.bus_line_qty}}
                          </div>
                          <div>{{this.selected_package.description}}
                          </div>
                          <div>{{ $t('message.Package_Validity') }}: {{this.packageValidityPeriod}}
                          </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
                
              </el-tab-pane>

            </el-tabs>
            <div style="margin-top: 20px;">

              <el-row v-if="chosen_city=='Shenzhen' || chosen_city=='Chongqing' || chosen_city=='Chengdu'" :gutter="24">
                <!-- big screen -->
                <el-col :span="6" class="hidden-md-and-down">
                  <el-row>
                    <el-col :span="12" class="info_label" style="margin-top: 0">
                      {{ $t('message.Population') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value" style="margin-top: 0">
                      {{total_num_population}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Bus_Lines') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{bus_line_number}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Bus_network_length') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{total_bus_length}}km
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Bus_stops') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{bus_stop_number}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Total_AOI') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{aoi_number}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Total_POI') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{poi_number}}
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="9" :offset="1" class="hidden-md-and-down">
                  <div>
                    <div style="font-size: 20px">
                      {{$t('message.Hourly_Pattern_Audience_Distribution')}}
                    </div>
                    <line-chart style="height: 230px; margin-top: 10px;" :chart-data="datacollection_hourly_pattern" :options="chart_options_hourly_pattern"></line-chart>
                  </div>
                </el-col>
                <el-col :span="8" class="hidden-md-and-down">
                  <div style="font-size: 20px">
                    {{$t('message.Distribution_of_road_types')}}
                  </div>
                  <div style="width: 100%;height:250px;" ref="chart_big_screen"></div>
                </el-col>
                <!-- small screen -->
                <el-col :span="24" class="hidden-lg-and-up">
                  <el-row>
                    <el-col :span="12" class="info_label" style="margin-top: 0">
                      {{ $t('message.Population') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value" style="margin-top: 0">
                      {{total_num_population}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Bus_Lines') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{bus_line_number}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Bus_network_length') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{total_bus_length}}km
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Bus_stops') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{bus_stop_number}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Total_AOI') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{aoi_number}}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="info_label">
                      {{ $t('message.Total_POI') }} : 
                    </el-col>
                    <el-col :span="12" class="info_value">
                      {{poi_number}}
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="20" :offset="2" class="hidden-lg-and-up">
                  <div>
                    <div style="font-size: 20px; margin-top: 30px">
                      {{$t('message.Hourly_Pattern_Audience_Distribution')}}
                    </div>
                    <line-chart style="height: 230px; margin-top: 10px;" :chart-data="datacollection_hourly_pattern" :options="chart_options_hourly_pattern"></line-chart>
                  </div>
                </el-col>
                <el-col :span="24" class="hidden-lg-and-up">
                  <div style="font-size: 20px; margin-top: 30px">
                    {{$t('message.Distribution_of_road_types')}}
                  </div>
                  <div style="width: 100%;height:250px;" ref="chart_small_screen"></div>
                </el-col>
              </el-row>

              
              <el-row v-else :gutter="24">
                <el-col :span="12">
                  <div>
                    <p class="p_title">{{ $t('message.Population') }}</p>
                    <p class="p_num1"><strong>{{total_num_population}}</strong></p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    <p class="p_title">{{ $t('message.Bus_Lines') }}</p>
                    <p class="p_num1"><strong>{{bus_line_number}}</strong></p>
                  </div>
                </el-col>
                <!--
                <el-col :span="24" style="margin-top: 20px" v-if="chosen_city=='first'">
                  <div style="display: inline-block;">
                    <el-card :body-style="{ padding:'10px', background: '#f8f8f9'}">
                      <a href="https://digital-quiz.jcdecauxchina.com.cn/"><img src="../src/assets/qr_code.png" style="width: 100px"></a> 
                      <div class="el-alert el-alert--info is-light" style="width: auto; display: inline-flex; vertical-align: middle; color: #409eff; background: #ecf5ff">
                        <i class="el-icon-back is-big" style="border-radius: 50%; background: #409eff; color: white; font-size: 30px"></i>
                        <div class="el-alert__content">
                          <span class="el-alert__title is-bold">{{ $t('message.Quiz_pub')}}</span>
                          <p class="el-alert__description">文字说明文字说明文字说明文字说明文字说明文字说明</p>
                        </div>
                      </div>
                    </el-card>
                  </div>
                </el-col>
                -->
              </el-row>
              
              <!--
              <el-row :gutter="24">
                <el-col :span="12">
                  <div>
                    <p class="p_title">{{ $t('message.Population') }}</p>
                    <p class="p_num1"><strong>{{total_num_population}}</strong></p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    <p class="p_title">{{ $t('message.Bus_Lines') }}</p>
                    <p class="p_num1"><strong>{{bus_line_number}}</strong></p>
                  </div>
                </el-col>
              </el-row>
              -->
            </div>
          </div>
        </div>

        <!-- proposal status reminder -->
        <el-dialog :title="dialogStatusTitleText" width="90%" :visible.sync="dialogStatusVisible"
          :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true"
          >
          <div :style="{height:  (0.9*pageHeight-225)+'px' , overflowY: 'auto'}">
            <el-table :data="statusTableData" :row-class-name="tableRowClassName">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="Impressions">
                          <span>{{ props.row.impressions }}</span>
                        </el-form-item>
                        <el-form-item label="Total Bus Line">
                          <span>{{ props.row.total_bus_line }}</span>
                        </el-form-item>
                        <el-form-item label="Total Media Budget">
                          <span>{{ props.row.total_media_budget }}</span>
                        </el-form-item>
                        <el-form-item label="Apply Discount">
                          <span>{{ props.row.discount }}</span>
                        </el-form-item>
                        <el-form-item label="Discounted Media Budget">
                          <span>{{ props.row.discounted_media_budget }}</span>
                        </el-form-item>
                        <el-form-item label="Package Name">
                          <span>{{ props.row.package_name }}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column :label="$t('message.Status')" prop="status" min-width=140>
                <template slot-scope="scope1">
                  <div>
                      <el-select v-if="scope1.row.isChanged"
                      v-model="scope1.row.status"
                      @change="handleChange(scope1.row,scope1.$index)"
                      @blur="handleBlur(scope1.row,scope1.$index)"
                      >
                      <el-option 
                        v-for="item in scope1.row.status_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label">
                        <span style="float: left">{{ item.label }}</span>
                        <span>
                          <div class="circle" :class="{ white: (item.value == '1'), discussion: (item.value == '2'),
                          gray: (item.value == '3'), win: (item.value == '4'), black: (item.value == '5'),
                          darkgrey: (item.value == '6'), green: (item.value == '7')
                          }"></div>
                        </span>
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <div style="cursor:pointer;margin:10px 0; width: 100px; text-align: center;"
                          v-if="!scope1.row.isChanged"
                          @click="handleSelect(scope1.row,scope1.$index)"
                          :class="{ white:(scope1.row.status == $t('message.Draft')), discussion: (scope1.row.status == $t('message.Discussion')),
                          gray: (scope1.row.status == $t('message.Sent')), win: (scope1.row.status == $t('message.Win')), black: (scope1.row.status == $t('message.Fail')),
                          darkgrey: (scope1.row.status == $t('message.Cancelled')), green: (scope1.row.status == $t('message.Archive'))}">
                          
                          {{scope1.row.status}}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('message.Created_at')" prop="createdAt" width = "180">
              </el-table-column>
              <el-table-column :label="$t('message.Updated_at')" prop="updatedAt" width = "180">
              </el-table-column>
              <el-table-column :label="$t('message.Client_name')" prop="clientName">
              </el-table-column>
              <el-table-column :label="$t('message.City')" prop="city">
              </el-table-column>
              <el-table-column :label="$t('message.Campaign_start')" prop="campaignStart">
              </el-table-column>
              <el-table-column :label="$t('message.Campaign_end')" prop="campaignEnd">
              </el-table-column>
            </el-table>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeStatusDialog">
              {{$t('message.Got_it')}}
            </el-button>
          </span>
        </el-dialog>

      </el-main>
      <el-dialog
        :title="$t('message.add_external_user')"
        :visible.sync="addDialoFormVisible"
        v-loading="dialogFormLoading"
        width=68%
      >
      <el-row style="margin:10px;height:40px">
            <el-col :span="7" style="text-align: left;">
                <span style="font-size: 14px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.new_password')}}</span>
            </el-col>
            <el-col :span="16" :offset="1">
              <el-input  show-password  v-bind:placeholder="$t('message.new_password')" v-model="input_pwd" clearable> <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
             


            </el-col>
        </el-row>
        <el-row style="margin:10px;height:40px">
          <el-col :span="7" style="text-align: left;">
            <span style="font-size: 14px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.confirm_new_password')}}</span>
          </el-col>
          <el-col :span="16" :offset="1">
            <el-input show-password  v-bind:placeholder="$t('message.confirm_new_password')" v-model="input_pwd_again" clearable><i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
           </el-col>
        </el-row>
      <div slot="footer" class="dialog-footer">
          <el-button @click="addDialogFormVisible = false">{{
            $t("message.Cancel")
          }}</el-button>
          <el-button type="primary" @click="updatePassword()">{{
            $t("message.Confirm")
          }}</el-button>
          </div>
    </el-dialog>
    </el-container>

  </div>

</template>

<script>
  import head_page from './components/head_page.vue'
  import head_menu from './components/head_menu.vue'
  import toggle_menu from './components/toggle_menu'
  import axios from 'axios';
  import _global from './components/global.vue';
  import HorizontalBarChart from './components/HorizontalBarChart.js';
  import LineChart from './components/LineChart.js';

  export default {
    name: 'choose_city',
    data() {
      return {
        addDialoFormVisible:false,
        dialogFormLoading:false,
        input_pwd:'',
        input_pwd_again:'',
        alreadyClicked:false,
        version :'',
        num_population: 0,
        num_audience: 0,
        submit_show: false,
        city_info: '',
        chosen_city: "CHOOSE YOUR CITY",
        total_num_population: 0,
        total_num_audience: 0,
        bus_line_number: 0,
        total_bus_length: 0,
        bus_stop_number: 0,
        aoi_number: 0,
        poi_number: 0,
        hover: false,
        first_page: true,
        user: 'Visitor',
        user_name: 'Visitor',
        style_nanjing: false, //to be city_list['Nanjing']=false
        style_wuhan: false,
        num_bus_line: 0,
        num_kms_covered: 0,
        lang: 'en',
        loading: false,
        activeName: 'first',
        dataValueBadge: 0,
        // isAll:false,
        // isNanjing:false,
        // isWuhan:false,
        // isShenzhen:false,
        is_national : false,
        view_nanjing : false,
        view_wuhan : false,
        view_shenzhen : false,
        view_chongqing : false,
        view_chengdu : false,
        view_shanghai : false,
        view_statistics:false,
        view_package_list:false,
        is_admin:false,
        is_external_user: false,
        create_crosscity: false,
        inventory_nanjing: false,
        inventory_wuhan: false,
        inventory_shenzhen: false,
        inventory_chongqing: false,
        inventory_chengdu: false,
        published_package_list:[],
        selected_package_package_id:'',
        selected_package:{},
        notExistPackageId:true,
        //isDirector:false,
        packageValidityPeriod:'',
        pageWidth: screen.width,
        pageHeight: window.innerHeight,
        dialogStatusVisible: false,
        dialogStatusShowClose: false,
        dialogStatusCountdown: 60,
        dialogStatusCountdownInterval: {},
        statusTableData: [],
        status_options: [{
          value: '1',
          label: this.$t('message.Draft')
        }, {
          value: '2',
          label: this.$t('message.Discussion')
        }, {
          value: '3',
          label: this.$t('message.Sent')
        }, {
          value: '4',
          label: this.$t('message.Win')
        }, {
          value: '5',
          label: this.$t('message.Fail')
        }, {
          value: '6',
          label: this.$t('message.Cancelled')
        }, /*{
          value: '7',
          label: this.$t('message.Archive')
        }*/],
        city_options: [{
          value: 'Nanjing',
          label: this.$t('message.Nanjing')
        }, {
          value: 'Wuhan',
          label: this.$t('message.Wuhan')
        }, {
          value: 'Shenzhen',
          label: this.$t('message.Shenzhen')
        }, {
          value: 'Chongqing',
          label: this.$t('message.Chongqing')
        },{value: 'Chengdu',
          label: this.$t('message.Chengdu')
        }],
        selected_cities: [],
        backend_url: _global.serverSrc,
        /*
        datacollection_road_type: {
          labels: [this.$t('message.1W-2L-R'), this.$t('message.1W-3L-R'), this.$t('message.2W-2L-R'), this.$t('message.2W-4L-R'), this.$t('message.2W-6L-R'), this.$t('message.2W-8L-R'), this.$t('message.Highway')],
          datasets: [{
            label: "Proportion",
            backgroundColor: '#B2DFDB',
            data: [0,0,0,0,0,0,0]
          }]
        },
        chart_options_road_type: {
          maintainAspectRatio: false,
          responsive: true,
          tooltips: {
            enabled: false,
          },
          legend: {
              display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                fontSize: 15,
                max: 50,
                callback: function(value, index, values) {
                  return value+'%';
                },
              },
            }],
          },
          hover: {
            animationDuration: 0
          },
          animation: {
            duration: 1,
            onComplete: function() {
              var chartInstance = this.chart,
                ctx = chartInstance.ctx;

              ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
              ctx.textAlign = 'left';
              ctx.textBaseline = 'bottom';

              this.data.datasets.forEach(function(dataset, i) {
                var meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach(function(bar, index) {
                  var data = dataset.data[index] + "%";
                  ctx.fillText(data, bar._model.x, bar._model.y+5);
                });
              });
            }
          }
        },
        */
        datacollection_hourly_pattern: {
          //labels: ["0h","1h","2h","3h","4h","5h","6h","7h","8h","9h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h","24h"],
          labels: ["5h","6h","7h","8h","9h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h","24h"],
          datasets: [
            {
              label: this.$t('message.Workday'),
              borderColor: '#0D47A1',
              fill: false,
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              label: this.$t('message.Weekend'),
              borderColor: '#4DB6AC',
              fill: false,
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
          ]
        },
        chart_options_hourly_pattern: {
          maintainAspectRatio: false,
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                fontSize: 15,
                max: 12,
                callback: function(value, index, values) {
                  return value+'%';
                },
                display: false
              },  
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }  
            }],
          },
          tooltips: {
            callbacks: {
              label: function(t, d) {
                const label = d.datasets[t.datasetIndex].label;
                const value = d.datasets[t.datasetIndex].data[t.index];
                return `${label}: ${value.toFixed(2)}%`;
              }
            }
          },
        },
        road_type_info: [],
        road_type_chart_big: undefined,
        road_type_chart_small: undefined,
      }
    },
    computed: {
      day: function() {
        let week;
        let date = new Date();
        if (date.getDay() == 0) week = this.$t('message.Sunday')
        if (date.getDay() == 1) week = this.$t('message.Monday')
        if (date.getDay() == 2) week = this.$t('message.Tuesday')
        if (date.getDay() == 3) week = this.$t('message.Wednesday')
        if (date.getDay() == 4) week = this.$t('message.Thursday')
        if (date.getDay() == 5) week = this.$t('message.Friday')
        if (date.getDay() == 6) week = this.$t('message.Saturday')

        return week;
      },
      date: function() {
        let date_org = new Date();
        let date_arr = String(date_org).split(" ");
        if (date_arr[1] == 'Jan') date_arr[1] = this.$t('message.Jan')
        if (date_arr[1] == 'Feb') date_arr[1] = this.$t('message.Feb')
        if (date_arr[1] == 'Mar') date_arr[1] = this.$t('message.Mar')
        if (date_arr[1] == 'Apr') date_arr[1] = this.$t('message.Apr')
        if (date_arr[1] == 'May') date_arr[1] = this.$t('message.May')
        if (date_arr[1] == 'Jun') date_arr[1] = this.$t('message.Jun')
        if (date_arr[1] == 'Jul') date_arr[1] = this.$t('message.Jul')
        if (date_arr[1] == 'Aug') date_arr[1] = this.$t('message.Aug')
        if (date_arr[1] == 'Sep') date_arr[1] = this.$t('message.Sep')
        if (date_arr[1] == 'Oct') date_arr[1] = this.$t('message.Oct')
        if (date_arr[1] == 'Nov') date_arr[1] = this.$t('message.Nov')
        if (date_arr[1] == 'Dec') date_arr[1] = this.$t('message.Dec')
        return date_arr[2] + ' ' + date_arr[1] + ' ' + date_arr[3];
      },
      localLang() {
        return this.$i18n.locale;
      },
      dialogStatusCloseText() {
        if (this.dialogStatusShowClose) {
          return this.$t('message.Got_it')
        } else {
          return this.dialogStatusCountdown + "s"
        }
      },

      dialogStatusTitleText() {
        if (this.statusTableData.length > 0) {
          let title = this.$t('message.Proposal_Status_Reminder_number').replace("{{number}}", this.statusTableData.length)
          title = (this.statusTableData.length==1) ? title.replace("proposals", "proposal") : title
          return title
        }
        else {
          return this.$t('message.Proposal_Status_Reminder')
        }
      }
    },
    watch:{
      selected_package_package_id: function(){
        for (let ele in this.published_package_list) {
          if(this.published_package_list[ele]['package_id']==this.selected_package_package_id){
              this.selected_package = this.published_package_list[ele]
              //Update packageValidityPeriod with Character from/to
              this.packageValidityPeriod = this.$t('message.From') + ' ' + this.selected_package.valid_period_start + ' ' + this.$t('message.to')+ ' ' + this.selected_package.valid_period_end
          }
        } 
        this.$store.state.package.selected_package.selected_package_package_id = this.selected_package_package_id
        if(this.selected_package_package_id != ''){
          this.notExistPackageId = false
        }else{
          this.notExistPackageId = true
        }
      },
      localLang() {
        if (this.packageValidityPeriod && this.packageValidityPeriod.length>0) {
          this.packageValidityPeriod = this.$t('message.From') + ' ' + this.selected_package.valid_period_start + ' ' + this.$t('message.to')+ ' ' + this.selected_package.valid_period_end
        }
        this.city_options = [{
          value: 'Nanjing',
          label: this.$t('message.Nanjing')
        }, {
          value: 'Wuhan',
          label: this.$t('message.Wuhan')
        }, {
          value: 'Shenzhen',
          label: this.$t('message.Shenzhen')
        },{
            value: 'Chongqing',
            label: this.$t('message.Chongqing')
        },{
            value: 'Chengdu',
            label: this.$t('message.Chengdu')
          }]

        //this.datacollection_road_type.labels = [this.$t('message.1W-2L-R'), this.$t('message.1W-3L-R'), this.$t('message.2W-2L-R'), this.$t('message.2W-4L-R'), this.$t('message.2W-6L-R'), this.$t('message.2W-8L-R'), this.$t('message.Highway')]
        //this.datacollection_road_type = {...this.datacollection_road_type}
        
        this.datacollection_hourly_pattern.datasets[0].label = this.$t('message.Workday')
        this.datacollection_hourly_pattern.datasets[1].label = this.$t('message.Weekend')
        this.datacollection_hourly_pattern = {...this.datacollection_hourly_pattern}

        if (this.chosen_city=="Shenzhen" || this.chosen_city=="Chongqing") {
          this.loadRoadTypeChart()
        }
      }
    },
    components: {
      head_page,
      head_menu,
      toggle_menu,
      HorizontalBarChart,
      LineChart,
    },
    created() {
      this.loading = true;
      if (JSON.parse(sessionStorage.getItem('User')) != null) {
        const name_arr = JSON.parse(sessionStorage.getItem('User')).split('@')[0].split('.')
        this.user = name_arr[0].toUpperCase();
        this.user_name = name_arr[0].toUpperCase() + " " + name_arr[1].toUpperCase()
      }
      window.addEventListener("resize", this.resizeHandler);     
      window.addEventListener("keydown", this.closeDialogHandler);
    },
    mounted() {
      this.getPageAuthority()
      this.getCityInfo();
      this.getReportLength()
      this.getHistoryData()

      this.$refs.head_page.update_user_name();
      this.lang = JSON.parse(sessionStorage.getItem('lang'));
      this.$i18n.locale = this.lang;
      this.$refs.head_page.switchLang(this.lang);
      this.chosen_city = 'first';
      //this.setActiveTab()

    },
    updated() {
      if (this.total_num_population & this.total_num_audience == 0) {
        this.open1();
      }
    },
    methods: {
      updatePassword(){
       
        // check pwd and pwd_again is not null
        if (this.input_pwd == '' || this.input_pwd_again == '' ){
          this.$message({
            type: "error",
            message:this.$t("message.pwd_cannot_be_null"),
          });
        } else if (this.input_pwd != this.input_pwd_again){
          this.$message({
            type: "error",
            message: this.$t("message.pwd_inconsistent"),
            
          });
        } 
        else if(this.input_pwd.length < 12){
          this.$message({
            type: "error",
            message: this.$t("message.pwd_length_longer_than_12"),
            
          });

        } else if(!this.input_pwd.match("(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])")){
          this.$message({
            type: "error",
            message: this.$t("message.pwd_contains_character"),
          });
        }
        else {
          // check new password has been used before
          let api_url = _global.serverSrc + "/check_password_used/";
          let obj = {
            pwd:this.input_pwd,
            email: JSON.parse(sessionStorage.getItem('User'))
          }
          axios.post(api_url, obj).then((response)=>{
            if (response.data.result_code == true ){
              this.$message({
                type: "error",
                message:this.$t("message.pwd_not_repeated"),
              });
            } else {
              api_url = _global.serverSrc + "/update_external_user_pwd/";
         
              axios
                .post(api_url, obj)
                .then((response) => {
                  if (response.data.status_code == 'success'){
                    this.$message({
                    type: 'success',
                    message: this.$t('message.Data_is_saved')
                  });
                  this.addDialoFormVisible = false

                  axios
                  .post( _global.serverSrc + "/log_in/",  {
                      email: JSON.parse(sessionStorage.getItem('User')),
                      password: this.input_pwd,
                    })
                    .then((response) => {
                      

                      let userAuthority = {
                        user_id : response.data[0].user_id,
                        is_jcd_domain : response.data[0].is_jcd_domain,
                        is_register_user : response.data[0].is_register_user,
                        is_national : response.data[0].is_national,
                        view_nanjing : response.data[0].view_nanjing,
                        view_wuhan : response.data[0].view_wuhan,
                        view_shenzhen : response.data[0].view_shenzhen,
                        view_chongqing : response.data[0].view_chongqing,
                        view_chengdu : response.data[0].view_chengdu,
                        view_shanghai : response.data[0].view_shanghai,
                        inventory_nanjing : response.data[0].inventory_nanjing,
                        inventory_wuhan : response.data[0].inventory_wuhan,
                        view_statistics : response.data[0].view_statistics,
                        view_package_list : response.data[0].view_package_list,
                        is_admin : response.data[0].is_admin,
                        create_package : response.data[0].create_package,
                        create_crosscity : response.data[0].create_crosscity,
                        //update_report_status : response.data[0].update_report_status,
                        share_proposal : response.data[0].share_proposal,
                        bu : response.data[0].bu,
                        role : response.data[0].role,
                        discount : response.data[0].discount,
                      }
                      if (response.data[0].is_register_user) {
                        sessionStorage.setItem("UserAuthority", JSON.stringify(userAuthority));
                        sessionStorage.setItem("SlidingToken", JSON.stringify(response.data[0].sliding_token));
                        this.$router.push({
                          path: "/choose_city",
                        });
                      } else {
                        this.noticeWrongPwd();
                      }
                    })
                  }
                  
                })



            }


          })


          // change pwd
         


        }

      },
      noticeWrongPwd() {
      const h = this.$createElement;
      this.$notify({
        title: "Error",
        message: h(
          "i",
          {
            style: "color: teal",
          },
          "Please check your email and password."
        ),
      });
    },
      goChangePwd(){
        this.addDialoFormVisible = true
      },
    
      getPageAuthority(){
        if (JSON.parse(sessionStorage.getItem('UserAuthority')) != null) {
          let userAuthority = JSON.parse(sessionStorage.getItem('UserAuthority'));
          this.is_national = userAuthority['is_national']
          this.view_nanjing = userAuthority['view_nanjing']
          this.view_wuhan = userAuthority['view_wuhan']
          this.view_shenzhen = userAuthority['view_shenzhen']
          this.view_chongqing = userAuthority['view_chongqing']
          this.view_chengdu = userAuthority['view_chengdu']
          this.view_shanghai = userAuthority['view_shanghai']
          this.inventory_nanjing = userAuthority['inventory_nanjing']
          this.inventory_wuhan = userAuthority['inventory_wuhan']
          this.inventory_shenzhen = userAuthority['inventory_shenzhen']
          this.inventory_chongqing = userAuthority['inventory_chongqing']
          this.inventory_chengdu = userAuthority['inventory_chengdu']
          this.view_statistics = userAuthority['view_statistics']
          this.view_package_list = userAuthority['view_package_list']
          this.is_admin = userAuthority['is_admin']
          this.is_external_user = userAuthority['is_external_user']
          this.create_crosscity = userAuthority['create_crosscity']
        }
        
      },
      
      // getCityAccess() {
      //   let api_url = _global.serverSrc + '/city_access_check/';
      //   let obj = new Object()
      //   obj.email = JSON.parse(sessionStorage.getItem('User'))
      //   axios.post(api_url, obj)
      //     .then(response => {
      //       let city_access = JSON.parse(response.data[0].city_access.replace(/'/g,'\"'))
      //       if (city_access.indexOf("National")>=0) {
      //         this.isAll=true
      //       }else if (city_access.indexOf("Nanjing")>=0){
      //         this.isNanjing = true
      //       }else if (city_access.indexOf("Wuhan")>=0){
      //         this.isWuhan = true
      //       }
      //     })
      //     .catch(function(error) {});
      // },
      
      getReportLength() {
        let api_url = _global.serverSrc + '/report_length/' + '?format=json';
        let obj = new Object()
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.report_length) {
              this.dataValueBadge = response.data.report_length[0].report_number
            }
          })
          .catch(function(error) {});
      },
      goHistory() {
        this.$router.push('./history')
      },
      goBussinessStatistics(){
        this.$router.push('./statistics')
      },
      goStatistics() {
        this.$router.push('./statistics_v2')
      },
      goUserMangement() {
        this.$router.push('./usermangement')
      },
      goInternalUserMangement() {
        this.$router.push('./internalusermanagement')
      },
      goExternalUserMangement() {
        this.$router.push('./externalusermanagement')
      },
      setActiveTab() {
        if (!this.view_nanjing && this.inventory_nanjing) {
          this.activeName = 'Nanjing'
          this.chosen_city = 'Nanjing';
        }
        if (!this.view_wuhan && this.inventory_wuhan) {
          this.activeName = 'Wuhan'
          this.chosen_city = 'Wuhan';
        }
        if (!this.view_shenzhen && this.inventory_shenzhen) {
          this.activeName = 'Shenzhen'
          this.chosen_city = 'Shenzhen';
        }
        if (!this.view_chongqing && this.inventory_chongqing) {
          this.activeName = 'Chongqing'
          this.chosen_city = 'Chongqing';
        }
        if (!this.view_chengdu && this.inventory_chengdu) {
          this.activeName = 'Chengdu'
          this.chosen_city = 'Chengdu';
        }
      },
      handleClick(tab, event) {
        this.alreadyClicked = true
        this.chosen_city = tab.name
        this.road_type_chart_big = undefined
        this.road_type_chart_small = undefined
        if (tab.index == 0) {
          //  global
          this.getCityInfo()
          //this.version = this.getLastVersion('选择城市')
        } else if (tab.name == "Nanjing") {
          // Nanjing
          this.getCityInfoByName('Nanjing')
          this.resetPackageList()
          this.getPackageList('Nanjing')
          //this.version = this.getLastVersion('Nanjing')
        } else if (tab.name == "Wuhan") {
          // Wuhan
          this.getCityInfoByName('Wuhan')
          this.resetPackageList()
          this.getPackageList('Wuhan')
          //this.version = this.getLastVersion('Wuhan')
        } else if (tab.name == "Shenzhen") {
          // Shenzhen
          this.getCityInfoByNameV2('Shenzhen')
           //this.getCityInfoByName('Shenzhen')
          this.resetPackageList()
          this.getPackageList('Shenzhen')
        } else if (tab.name == "Chongqing") {
          // Chongqing
          this.getCityInfoByNameV2('Chongqing')
          //this.getCityInfoByName('Chongqing')
          this.resetPackageList()
          this.getPackageList('Chongqing')
        } else if (tab.name == "Chengdu") {
          // Chongqing
          this.getCityInfoByNameV2('Chengdu')
          this.resetPackageList()
          this.getPackageList('Chengdu')
        } else if (tab.name == "Shanghai") {
          this.getCityInfoByName('Shanghai')
          this.resetPackageList()
          this.getPackageList('Shanghai')
        }
      },

      goNanjing: function(event) {
        this.getCityInfoByName(event);
        this.submit_show = true;
        this.chosen_city = this.$i18n.messages[this.$i18n.locale].message.Nanjing;
        this.first_page = false;
        this.style_nanjing = true;
        this.style_wuhan = false;
      },

      goWuhan: function(event) {
        this.getCityInfoByName(event);
        this.submit_show = true;
        this.chosen_city = this.$i18n.messages[this.$i18n.locale].message.Wuhan;
        this.first_page = false;
        this.style_wuhan = true;
        this.style_nanjing = false;
      },
      open1() {
        const h = this.$createElement;
        this.$notify({
          title: 'Server Error',
          message: h('i', {
            style: 'color: teal'
          }, message.Please_Contact_IT)
        });
      },

      getCityInfo() {
        let api_url = _global.serverSrc + '/city_info/' + '?kvalue=';
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data) {
              this.city_info = response.data.city_info;
              let total_audience = 0;
              let total_population = 0;
              let bus_line_number = 0;
              let total_bus_length = 0;
              for (let ele in response.data.city_info) {
                total_audience += response.data.city_info[ele].audience;
                total_population += response.data.city_info[ele].population;
                bus_line_number += response.data.city_info[ele].bus_line_number;
                total_bus_length += response.data.city_info[ele].total_bus_length;
              }
              this.total_num_population = total_population.toLocaleString();
              this.total_num_audience = total_audience.toLocaleString();
              this.bus_line_number = bus_line_number.toLocaleString();
              this.total_bus_length = total_bus_length.toLocaleString();
            }
            //this.loading = false;
          })
          .catch(function(error) {
            //this.loading = false;
          });
      },
      goTraining: function(e){
        
        const quizSrc = 'http://10.11.1.87:8060/#/quiz';
        window.open(quizSrc);
      },

      doSubmit: function(event) {
        if (this.chosen_city) {

          this.$router.push({
            path: '/information',
            query: {
              chosen_city: this.chosen_city
            }
          });
        } else {
          this.open2();
        }

      },
      open2: function() {
        const h = this.$createElement;
        this.$notify({
          title: this.$i18n.messages[this.$i18n.locale].message.Error,
          message: h('i', {
            style: 'color: teal'
          }, this.$i18n.messages[this.$i18n.locale].message.Please_select_a_city_first)
        });
      },
      goInventoryList() {
        if (this.chosen_city) {
          this.$router.push({
            path: '/inventory_list',
            query: {
              chosen_city: this.chosen_city
            }
          });
        }
      },
      goHome: function(event) {
        this.$router.go(0);
      },
      backToLogin: function(event) {
        this.$router.push({
          path: '/',
        });
      },
      goPackage(){
        this.$router.push({
          path: '/package_history',
        });
      },
      getCityInfoByName: function(city_name) {
        let api_url = _global.serverSrc + '/city_info/' + '?kvalue=' + city_name;
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        var _self = this;
        this.$axios.post(api_url, obj).then(response => {
            if (response.data) {
              _self.total_num_population = response.data.city_info[0]['population'].toLocaleString();
              _self.total_num_audience = response.data.city_info[0]['audience'].toLocaleString();
              _self.bus_line_number = response.data.city_info[0]['bus_line_number'].toLocaleString();
              _self.total_bus_length = response.data.city_info[0]['total_bus_length'].toLocaleString();
            }
            //_self.loading = false;
          })
          .catch(function(error) {
            //_self.loading = false;
          });
        this.chosen_city = city_name;
      },
      getCityInfoByNameV2: function(city_name) {
        let api_url = _global.serverSrc + '/city_info_v2/' + '?kvalue=' + city_name;
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        this.$axios.post(api_url, obj).then(response => {
            if (response.data) {
              this.total_num_population = response.data.city_info[0]['population'].toLocaleString();
              this.total_num_audience = response.data.city_info[0]['audience'].toLocaleString();
              this.bus_line_number = response.data.city_info[0]['bus_line_number'].toLocaleString();
              this.total_bus_length = response.data.city_info[0]['total_bus_length'].toLocaleString();
              this.bus_stop_number = response.data.city_info[0]['bus_stop_number'].toLocaleString();
              this.aoi_number = response.data.city_info[0]['aoi_number'].toLocaleString();
              this.poi_number = response.data.city_info[0]['poi_number'].toLocaleString();

              this.datacollection_hourly_pattern.datasets[0].data = response.data.workday_hour_pattern.map(info=>info.ratio)
              this.datacollection_hourly_pattern.datasets[1].data = response.data.weekend_hour_pattern.map(info=>info.ratio)
              this.datacollection_hourly_pattern = {...this.datacollection_hourly_pattern}
              
              this.road_type_info = response.data.road_type_info
              this.loadRoadTypeChart();

            }
            //_self.loading = false;
          })
          .catch(function(error) {
            //_self.loading = false;
          });
        this.chosen_city = city_name;
      },
      getPackageList(city_name){
        let api_url = _global.serverSrc + '/package_display/' 
        var _self = this;
        let published_package_list = []

        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.package_publish_status = 'NotExpired'

        this.$axios.post(api_url,obj).then(response => {
            if (response.data.package_list) {
              for (let ele of response.data.package_list){
                if (ele.publish_status ==1 && ele.city==city_name){
                  published_package_list.push(ele)
                }
              }
              //this.$store.state.package.published_package = response.data
            this.published_package_list = published_package_list
            }
            //_self.loading = false;
          })
          .catch(function(error) {
            //_self.loading = false;
          });
      },
      getHistoryData() {
        this.statusTableData = [];
        let api_url = _global.serverSrc + '/get_expired_status_user_history/?format=json';
        let obj = new Object()
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            this.dialogStatusVisible = true
            this.loading = false
            if (response.data.expired_status != null && response.data.expired_status.length>0) {
              for (let ele of response.data.expired_status) {
                let tmp = {}
                tmp.id = ele.reference_id
                tmp.createdAt = ele.created_at
                tmp.updatedAt = ele.updated_at
                tmp.city = ele.city
                tmp.clientName = ele.client_name
                tmp.campaignStart = ele.campaign_start
                tmp.campaignEnd = ele.campaign_end
                tmp.createdBy = ele.created_by
                tmp.impressions = Number(ele.viewed_impression).toLocaleString()
                tmp.total_media_budget = Number(ele.estimated_cost).toLocaleString()
                tmp.total_bus_line = Number(ele.number_bus)
                tmp.team = ele.bu_city
                tmp.status = this.proposalStatusChange(ele.proposal_status)
                tmp.isChanged = false
                tmp.status_options = this.createSelfOption(ele.proposal_status)
                tmp.package_id = ele.package_id
                tmp.package_name = ele.package_name
                tmp.proposal_status = ele.proposal_status
                tmp.is_shared = (ele.is_shared==1)
                this.statusTableData.push(tmp)
              }
            } 
            else {
              this.dialogStatusVisible = false;
              if (this.dialogStatusCountdownInterval) {
                clearInterval(this.dialogStatusCountdownInterval)
              }
            }
            if (sessionStorage.getItem("fromLogin") && this.statusTableData.length > 0) {
              this.dialogStatusVisible = true;
              this.dialogStatusCountdownInterval = setInterval(()=>{
                this.dialogStatusCountdown --
                if (this.dialogStatusCountdown == 0) {
                  clearInterval(this.dialogStatusCountdownInterval)
                  this.dialogStatusShowClose = true
                }
              }, 1000)
            }
            //sessionStorage.removeItem("fromLogin")
          })
          .catch(e => {
            this.loading = false
          })
      },
      resetPackageList(){
        this.selected_package_package_id = ''
        this.selected_package = {}
        this.published_package_list = {}

      },
      goPackageBoard(){
        //this.$router.push('./package_board')
        this.$store.state.package.selected_package.client_name=""
        this.$router.push({
              path: '/package_board',
              query: {
                back_url: '/choose_city'
              }
            });
      },
      goVersion(){
        this.$router.push({
          path: "/version",
          query: {
              chosen_city: this.chosen_city
            }
        });
      },
      getLastVersion(chosen_city){
        let api_url = _global.serverSrc + '/version_get/';
        let obj = {'chosen_city':chosen_city}
        axios.post(api_url,obj)
          .then(response => {
            this.htmlData = response.data[0]['text']
            this.version = response.data[0]['last_version']
            let h2reg = /name=".*?"/g;
            let array_result = [...this.htmlData.matchAll(h2reg)];
            this.listTitles = array_result.map(x=>x[0].substring(6,x[0].length-1))
          })
          .catch(function(error) {});
      },

      resizeHandler() {
        this.pageWidth = screen.width
        if (this.road_type_chart_big)
          this.road_type_chart_big.resize()
        if (this.road_type_chart_small)
          this.road_type_chart_small.resize()
      },

      closeDialogHandler(event) {
        if (event.key === "q" && event.ctrlKey) {
          this.closeStatusDialog();
        }
      },
      
      closeStatusDialog() {
        if (this.dialogStatusCountdownInterval) {
          clearInterval(this.dialogStatusCountdownInterval);
        }
        this.dialogStatusVisible = false;
      },
      
      tableRowClassName({row,rowIndex}){
        if(row.package_id && row.package_id != '') {
          return 'package-source-row'
        }else{
          return ''
        }
      },
      
      updateStatusOption: function(){
        this.status_options[0].label = this.$t('message.Draft')
        this.status_options[1].label = this.$t('message.Discussion')
        this.status_options[2].label = this.$t('message.Sent')
        this.status_options[3].label = this.$t('message.Win')
        this.status_options[4].label = this.$t('message.Fail')
        this.status_options[5].label = this.$t('message.Cancelled')
        //this.status_options[6].label = this.$t('message.Archive')
      },

      proposalStatusChange: function(val){
        this.updateStatusOption();
        for(let ele in this.status_options){
          if (this.status_options[ele].value == val){
            return this.status_options[ele].label
          }
        }
      },

      createSelfOption: function(status_code){
        let options = [...this.status_options]
        switch (status_code) {
          case 7: //Archive
                  options = options.filter(option=>{
                    return ["1","7"].includes(option.value)
                  })
                  break;
          case 6: //Cancelled
                  options = options.filter(option=>{
                    return ["1","6"].includes(option.value)
                  })
                  break;
          case 5: //fail
                  options = options.filter(option=>{
                    return option.value == "5"
                  })
                  break;
          case 4: //win
                  options = options.filter(option=>{
                    return option.value == "4"
                  })
                  break;
          case 3: //sent
                  options = options.filter(option=>{
                    return ["2","3","4","5"].includes(option.value)
                  })
                  break;
          case 2: //discussion
                  options = options.filter(option=>{
                    return ["4","5"].includes(option.value)
                  })
                  break;
          case 1: //draft
                  options = options.filter(option=>{
                    return ["2","3","6","7"].includes(option.value)
                  })
                  break;
          default:
            break;
        }

        return options
      },

      
      handleBlur:function(val,index){
          setTimeout(
            ()=>{
              this.statusTableData[index].isChanged = false
            },300
          )
      },
      handleChange:function(val,index){
        if (val.isChanged == true){
          this.statusTableData[index].isChanged = false
          this.statusTableData[index].status = val.status
          //发送信息更改数据库
          let api_url = _global.serverSrc + '/status_check/?format=json';
          let obj = {}
          obj.reference_id = val.id
          obj.status_code = this.inverseProposalStatusChange(val.status)
          obj.email = JSON.parse(sessionStorage.getItem('User'))
          this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.status_check != null) {
              if (response.data.status_check[0].is_ok==1){
                this.$notify({
                  message: this.$t('message.The_data_is_successfully_uploaded'),
                  position: 'top-left'
                });
                
              }else{
                this.$notify({
                  message: this.$t('message.No_Authority'),
                  position: 'top-left'
                });
              }
              this.getHistoryData()
            }
          })
          .catch(e => {
          })
        
        }
        
      },
      handleSelect:function(val,index){
        if (val.isChanged == false){
          this.statusTableData[index].isChanged = true
        }
      },
      inverseProposalStatusChange: function(val){
        for(let ele in this.status_options){
          if (this.status_options[ele].label == val){
            return this.status_options[ele].value
          }
        }
      },
      loadRoadTypeChart() {
        this.road_type_chart_big = this.$echarts.init(this.$refs.chart_big_screen);
        this.road_type_chart_small = this.$echarts.init(this.$refs.chart_small_screen);
        let option;
        let data = [];
        this.road_type_info.forEach(ele => {
          data.push(
            {
              type: ele.type,
              //name: this.$t('message.'+ele.type)+"\n"+ele.ratio.toFixed(2)+"%",
              name: this.$t('message.'+ele.type),
              value: ele.ratio.toFixed(2),              
            }
          )
        })
        option = {
          series: [
            {
              type: 'pie',
              width: '100%',
              height: '100%',
              radius: '50%',
              center: ['50%', '50%'],
              roseType: 'area',
              color: [ "#64B5F6", "#42A5F5", "#2196F3", "#1E88E5", "#1976D2", "#1565C0","#0D47A1"],
              itemStyle: {
                borderRadius: 8
              },
              label: {
                position: 'outside'
              },
              data: data.sort((a,b) => a.value-b.value),
              animation: false,
            },
          ],
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {d}%'
          },
        };
        option && this.road_type_chart_big.setOption(option);
        option && this.road_type_chart_small.setOption(option);
      },
      doCrossCity(){
        this.$router.push({
          path: "/cross_city_selection",
          query: {
            cities : this.selected_cities
          }
        });
      },
    },
    destroyed() {
      window.removeEventListener("resize", this.resizeHandler);
      window.removeEventListener("keydown", this.closeDialogHandler); 
    },
    
  }
</script>

<style lang="scss" scoped>
  .version_href{
    cursor: pointer;
    user-select: none;
    font-size: 20px;
  }
  
  .level3_div {
    height: 100px;
    margin: 20px;
  }

  .p_city_title_global {
    @media (max-width:767px) {
      color:#78877D;
      font-size: 14px;
      padding: 20px 40px 0 40px;
    }
    
    @media (min-width:768px) {
      color:#78877D;
      font-size: 16px;
      padding: 40px 40px 0 40px;
    }
    

    /deep/ input {
      height: 42px;
    }
  }
  
  .p_city_title {
    @media (max-width:767px) {
      color:white;
      font-size: 14px;
      padding: 20px 40px 0 40px;
    }
    
    @media (min-width:768px) {
      color:white;
      font-size: 16px;
      padding: 40px 40px 0 40px;
    }
  }

  .p_city_content_global {
    @media (max-width:767px) {
      color:#78877D;
      font-size: 40px;
      padding-left: 40px;
    }
    
    @media (min-width:768px) {
      color:#78877D;
      font-size: 60px;
      padding-left: 40px;
    }
  }

  .p_city_content_global {
    @media (max-width:767px) {
      color:#78877D;
      font-size: 40px;
      padding-left: 40px;
    }
    
    @media (min-width:768px) {
      color:#78877D;
      font-size: 60px;
      padding-left: 40px;
    }
  }

  .p_city_content {
    @media (max-width:767px) {
      color:white;
      font-size: 40px;
      padding-left: 40px;
    }
    
    @media (min-width:768px) {
      color:white;
      font-size: 60px;
      padding-left: 40px;
    }
  }

  .div_select_city {
    padding-top: 20px;
    padding-bottom: 40px;
    padding-left: 20px;
  }

  .popu_audience_div {
    width: 200px;
    display: inline-block;
    margin: 50px;
  }

  .popu_audience_div_dad {
    position: relative;
    width: 100%;
    text-align: center;
    height: 120px
  }

  .p_num1 {
    @media (max-width:767px) {
      font-size: 20px;
    }
    
    @media (min-width:768px) {
      font-size: 2.0rem;
    }
  }

  .p_title {
    @media (max-width:767px) {
      font-size: 20px;
    }
    
    @media (min-width:768px) {
      font-size: 25px;
    }
  }

  .submit_div {
    background-color: #9C9A99;
    color: #FFFFFF;
    height: auto;
    width: 20%;
    font-size: 22px;
    margin-left: 40%;
  }

  .el-tabs--top /deep/ .el-tabs__nav.is-top {
    @media (max-width:767px) {
      width: 100%;
      overflow-x: scroll;
    }
  }

  /deep/ .el-dialog {
    margin-top: 100px !important;
  }
  
  /deep/ .el-dialog__body {
    padding: 10px 20px;
  }

  @keyframes warning {
    from {text-shadow: 1px 1px rgba(255,0,0,1);}
    50% {text-shadow: 1px 1px rgba(255,0,0,0);}
    to {text-shadow: 1px 1px rgba(255,0,0,1);}
  }

  /deep/ .el-dialog__title {
    animation:warning 3s infinite;
  }

  .demo-table-expand label {
    width: 200px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }

  .demo-table-expand /deep/ .el-form-item__label {
    font-size: 12px;
    line-height: 24px;
  }

  .demo-table-expand /deep/ .el-form-item__content {
    font-size: 12px;
    line-height: 24px;
  }

  /deep/ .el-table__expanded-cell {
    padding: 0 50px;
  }

  .circle{
    border-radius: 100%;
    margin: 0.65em 0 0 8em;
    padding:4px;
    width: 8px;
    height: 8px;
  }

  /deep/ .el-upload-list {
    display: none;
  }

  #select_cities_button {
    text-align: center; 
    background-color: #254A6E; 
    font-size:16px;
    border: #2C3E50;
    border-style: solid;
    border-width:1px;
    color:white
  }

  #select_cities_button[disabled] {
    opacity: 0.5;
  }

  .info_label {
    text-align: right;
    font-size: 18px;
    margin-top: 20px;
  }

  .info_value {
    text-align: left;
    font-size: 18px;
    margin-top: 20px;
    padding-left: 10px;
    font-weight: bolder;
  }
  .gray{
    background-color:#95989be7;
  }
  .win{
    background-color: rgb(78,185,175)
  }
  .discussion{
    background-color: #c3c5c7ad;
  }
</style>
